module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm04_copy"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("NEW YORK UNIVERSITY PRESS"), _c('br'), _vm._v("New York and London"), _c('br'), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.nyupress.org",
      "target": "_blank"
    }
  }, [_vm._v("www.nyupress.org")])])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("© 2010 by New York University"), _c('br'), _vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Knight, Frederick C."), _c('br'), _vm._v("Working the diaspora : the impact of African labor on the Anglo-American world, 1650–1850 / Frederick C. Knight."), _c('br'), _vm._v("p. cm."), _c('br'), _vm._v("Includes bibliographical references and index."), _c('br'), _vm._v("ISBN-13: 978–0–8147–4818–3 (cl : alk. paper)"), _c('br'), _vm._v("ISBN-10: 0–8147–4818–x (cl : alk. paper)"), _c('br'), _vm._v("1. Slave labor—America—History. 2. Agricultural laborers—"), _c('br'), _vm._v("America—History. 3. Africans—America—History."), _c('br'), _vm._v("4. Blacks—America—History. 5. Agriculture—America—History."), _c('br'), _vm._v("6. African diaspora. I. Title."), _c('br'), _vm._v("HD4865.A45K65           2009"), _c('br'), _vm._v("331.11’7340970903—dc22             2009026860")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("New York University Press books are printed on acid-free paper, and their binding materials are chosen for strength and durability. We strive to use environmentally responsible suppliers and materials to the greatest extent possible in publishing our books.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Manufactured in the United States of America"), _c('br'), _vm._v("10 9 8 7 6 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12612b6d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm04_copy.vue
// module id = 69
// module chunks = 0